import React from 'react'
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import EmailIcon from "@material-ui/icons/Email"
import GitHubIcon from "@material-ui/icons/GitHub"
import "../styles/Home.css"
import Portrait from "../assets/KyleSoniPortrait.png"
import Mo1 from "../assets/mo1.jpeg"

function Home() {
  return (
    <div className="home">
        <div className="about"> 
            <img src={Portrait} alt=""/>
            <h2> Kyle Soni</h2>
            <div className="prompt"> 
                <p> 
                    A computer science, physics, and integrated science graduate interested in building a career in healthcare.
                </p>
                <a href='https://www.linkedin.com/in/kyle-soni-581636170/'>
                    <LinkedInIcon />
                </a>
                <a href='mailto:kylesoni2142@gmail.com'>
                    <EmailIcon />
                </a>
                <a href='https://github.com/kylesoni'>
                    <GitHubIcon />
                </a>
            </div>
        </div>
        <div className="skills">
            <ol className='list'>
                <li className='item'>
                    <h2> About</h2>
                    <p>
                        I'm a motivated and disciplined individual, fueled by intellectual curiosity and a passion for using technology and science to improve the world. As a recent graduate from Northwestern with majors in computer science, physics, and integrated science, I'm looking to use my broad knowledge of the natural sciences to build a career in healthcare.
                    </p>
                    <p>
                        I have strong skills in programming, data analysis, and problem solving. These skills have allowed me to be successful in multiple research areas, including neurobiology and network science, as well as large coding projects in areas like video games and natural language processing.
                    </p>
                    <p>   
                        My most recent experience gave me the opportunity to work as a research assistant on a theoretical network science project. In this role, I wrote and optimized code to generate large scale networks, analyzed existing networks from real-life datasets, and presented my findings at two academic conferences. Working closely with my team, we were able to create new models with differing behavior from the established literature.
                    </p>
                    <p>
                        My interdisciplinary background has given me a strong foundation for learning quickly in new environments, and I am searching for an opportunity where I can leverage and grow these skills.
                    </p>
                </li>
                <li className='item'>
                    <h2> Languages</h2>
                    <span> 
                        Python, C, C++, C#, R, JavaScript, CSS, Java, SQL
                    </span>
                </li>
                <li className='item'>
                    <h2> Technical Skills</h2>
                    <span>
                        Numpy, Matplotlib, Pandas, scikit-learn, Unix, Jupyter, Git, SDLC, Unity, Godot
                    </span>
                </li>
                <li className='item'>
                    <h2> Personal Interests</h2>
                    <ul>
                        <li>PC building</li>
                        <li>Playing drums and piano</li>
                        <li>My cat (pictured below)</li>
                    </ul>
                    <img src={Mo1} alt="" />
                    <figcaption> Mo Soni </figcaption>
                </li>
            </ol>
        </div>
    </div>
  )
}

export default Home